import React, { createContext, useContext } from 'react';
import { ItemId } from '../types';

export const TreeActionsContext = createContext({
  /* eslint-disable @typescript-eslint/no-unused-vars */
  setEdit: (id: ItemId, value: boolean) => {},
  rename: (id: ItemId, value: string) => {},
  deleteNode: (id: ItemId) => {},
});

interface Props {
  children: React.ReactNode;
  value?: any;
}

export const TreeActionsProvider = ({ children, value }: Props) => (
  <TreeActionsContext.Provider value={value}>
    {children}
  </TreeActionsContext.Provider>
);

export const useTreeActions = () => useContext(TreeActionsContext);
